import { z } from 'zod';

// export const passRegex =
//   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()-_=+])[A-Za-z\d!@#$%^&*()-_=+]{6,64}$/;

export const LoginSchema = z.object({
  username: z.string().min(1, { message: 'This field is required' }),
  password: z
    .string()
    .min(6, 'Minimum 6 character is required')
    .max(64, 'Max 64 characters are allowed')
});

export type LoginSchemaT = z.infer<typeof LoginSchema>;

// Explicitly specify the type for authInitials
export const loginInitials: LoginSchemaT = {
  username: '',
  password: ''
};
